import React, { FC, useState } from 'react'
import { Dropzone, IFile, IFileObject, mapDropzoneFiles } from 'transfix-ui/components/Dropzone'
import { IconButton } from 'transfix-ui/components/IconButton'
import { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { Box } from 'transfix-ui/core'
import { useUploadLanePreferences } from 'apps/marketplace/utils/hooks/useUploadLanePreferences'
import { DeleteIcon } from 'transfix-icons'
import { IModalBaseProps, ModalBase, MODAL_TYPES } from 'transfix-ui'

interface IPresourceModalProps extends Pick<IModalBaseProps, 'onClose'> {}

export const PresourceModal: FC<IPresourceModalProps> = ({ onClose }) => {
  const { openToast } = useGlobalToast()
  const [localFileList, setLocalFileList] = useState<IFile[]>([])
  const { error, isUploading, setError, uploadLanePreferences } = useUploadLanePreferences()

  const fileUploadHandler = (fileList: IFileObject[] = []) => {
    const pkgFiles = mapDropzoneFiles(fileList)
    setLocalFileList(pkgFiles)
  }

  const sendFile = async () => {
    const results = await uploadLanePreferences(localFileList[0])
    if (results?.updated) {
      openToast({
        toastMessage: 'File successfully uploaded',
        toastType: 'default',
      })
      onClose()
    }
  }

  const deleteFile = () => {
    setLocalFileList([])
    setError('')
  }

  return (
    <ModalBase
      title='Presource Carriers'
      size={4}
      open
      onClose={onClose}
      modalType={MODAL_TYPES.form}
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          dataTest: 'presource-cancel',
        },
        {
          label: 'Upload',
          type: 'confirm',
          disabled: localFileList.length === 0 || isUploading,
          dataTest: 'presource-submit',
          action: sendFile,
        },
      ]}
      bodyClassName='overflow'
      inlineMessageProps={
        error
          ? {
              message: error,
              type: INLINE_MESSAGE_VARIANTS.ALERT,
            }
          : undefined
      }>
      {localFileList.length < 1 ? (
        <Dropzone
          dropZoneText='Upload or drop CSV here'
          onFileChange={fileUploadHandler}
          acceptedFiles={[
            '.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values',
          ]}
          filesLimit={1}
        />
      ) : (
        <Box display='flex' alignItems='center'>
          {localFileList.map(file => {
            return (
              <Box display='inline' mr={1} key={file.fileFileName}>
                {file.fileFileName}
              </Box>
            )
          })}
          <IconButton
            Icon={DeleteIcon}
            color='tertiary'
            onClick={deleteFile}
            label='Delete'
            size='large'
          />
        </Box>
      )}
    </ModalBase>
  )
}
